module.exports = __webpack_public_path__ + "media/application/images/svgs/user-check-326537a8e743ee84f6a7b32317552d4d.svg";